








































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import User from "../../../store/entities/user";
@Component
export default class EditUser extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  user: User = new User();
  created() {}
  get roles() {
    return this.$store.state.user.roles;
  }
   get company() {
    return this.$store.state.company.list;
  }
  save() {
    (this.$refs.userForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "user/update",
          data: this.user,
        });
        (this.$refs.userForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.userForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.user = Util.extend(true, {}, this.$store.state.user.editUser);
    }
  }
  userRule = {
    userName: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("UserName")),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    phoneNumber: [
      {
        required: true,
        message: "请填写手机号",
        trigger: "blur",
      },
    ],
    emailAddress: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Email")),
        trigger: "blur",
      },
      { type: "email" },
    ],
    cId: [
      {
        type: "number",
        required: true,
        message: "请选择所属公司",
        trigger: "change",
      },
    ],
    newPwd:[
      {
        pattern:/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/,
        message:"密码强度不足!必须由大写字母、小写字母和数字或特殊字符三种及以上组合!（长度8位以上）",
        trigger:"blur",
      }
    ]
  };
}
